module.exports = __webpack_public_path__ + "img/sj.befbd62d.svg";